export function getServiceName(object = {}, services = []) {
    const service = services?.find(service => service.id === object.serviceId)
    return service ? service.name : (object.serviceName ?? '')
}
